import { Navigation, Virtual } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRef, useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import './styles.scss'
import { ISliderProps } from './types'

export const Slider = <T,>({ sliders, item }: ISliderProps<T>) => {
  const prevButtonRef = useRef<HTMLButtonElement>(null)
  const nextButtonRef = useRef<HTMLButtonElement>(null)
  const [isPrevDisabled, setIsPrevDisabled] = useState(true)

  return (
    <div className="swiper-container">
      <button
        ref={prevButtonRef}
        style={{ display: isPrevDisabled ? 'none' : 'flex' }}
        className="custom-prev"
      >
        <ChevronLeft />
      </button>

      <button ref={nextButtonRef} className="custom-next">
        <ChevronRight />
      </button>

      <Swiper
        modules={[Navigation, Virtual]}
        navigation={{
          prevEl: prevButtonRef.current,
          nextEl: nextButtonRef.current,
        }}
        onBeforeInit={(swiper) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const navigation = swiper.params.navigation as any
          navigation.prevEl = prevButtonRef.current
          navigation.nextEl = nextButtonRef.current
          swiper.navigation.init()
          swiper.navigation.update()
        }}
        onSlideChange={(swipe) => setIsPrevDisabled(swipe.isBeginning)}
        slidesPerView={3}
        spaceBetween={15}
        virtual
      >
        {sliders.map((row, index) => (
          <SwiperSlide key={index} virtualIndex={index}>
            {item(row)}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
